<template>
  <div class="round">
    <div class="title">
      <h3>{{ round.title[lang] }}</h3>
      <vue-dropdown class="actions" :actions="actions" @action="action"></vue-dropdown>
    </div>
    <div class="description">
      <p>{{ round.description[lang] }}</p>
    </div>
    <div class="end-date">
      <font-awesome-icon icon="calendar"></font-awesome-icon>
      <span>{{ round.closedate | date }} - {{ round.closedate | time }}</span>
    </div>
    <span :class="round.status" class="tag">{{ round.status }}</span>
    <round-integration :id="id" v-if="isIntegrationOpened" @close="isIntegrationOpened = false"></round-integration>
    <round-completion :id="id" v-if="isCompletionOpened" @close="isCompletionOpened = false"></round-completion>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import VueDropdown from '@kevindesousa/vue-dropdown'
import RoundIntegration from '@/components/rounds/round-integration.vue'
import RoundCompletion from '@/components/rounds/round-completion.vue'

export default {
  name: 'round-card',

  props: {
    id: {
      type: String,
      required: true
    }
  },

  components: { VueDropdown, RoundIntegration, RoundCompletion },

  data () {
    return {
      isIntegrationOpened: false,
      isCompletionOpened: false
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    ...mapGetters('rounds', {
      roundById: 'roundById'
    }),
    round () {
      return this.roundById(this.id)
    },

    actions () {
      let actions = []
      if (this.round.status === 'closed') {
        actions.push({
          title: 'Complete',
          action: 'complete',
          icon: null
        })
      }
      if (this.round.status === 'running') {
        actions.push({
          title: 'Edit',
          action: 'edit',
          icon: null
        })
      }

      actions.push({
        title: 'Integration',
        action: 'integration',
        icon: null
      })

      actions.push({
        title: 'Delete',
        action: 'delete',
        icon: null
      })
      if (this.round.status === 'terminated') {
        actions.push({
          title: 'Export ranking',
          action: 'download',
          icon: null,
        })
        actions.push({
          title: 'Retype result',
          action: 'retype',
          icon: null
        })
      }
      return actions
    }
  },

  methods: {

    ...mapActions('rounds', ['removeRound', 'unsetResultsdone']),

    action (action) {
      switch (action) {
      case 'edit':
        this.$router.push({ name: 'round-edit', params: { idContest: this.round.contestid, id: this.id } })
        break
      case 'integration':
        this.isIntegrationOpened = true
        break
      case 'complete':
        this.isCompletionOpened = true
        break
      case 'delete':
        this.deleteRound()
        break
      case 'download':
        const token = btoa(localStorage.getItem('token'));
        const url = process.env.API + '/contest/export/' + this.site.sitekey + '/contestround/' + this.round.id + `/?xtoken=${token}`;
        window.open(url, '_blank');
        break
      case 'retype':
        this.handleRetype();
        break
      default:
        break
      }
    },

    async handleRetype () {
      try {
        await this.unsetResultsdone({ round: this.round });
      } catch (error) {
        console.error(error);
      }
    },

    deleteRound () {
      this.removeRound({ round: this.round })
        .then(() => {
          this.$notify({
            title: 'Success',
            message: this.$root.$t('notifications.round.deleted')
          })
        })
        .catch(() => {
          this.$notify.error({
            title: 'Error',
            message: this.$root.$t('notifications.unknown')
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .round {
    background: #fff;
    padding: 12px 18px;
    box-shadow: 0 0.1875rem 1.5rem rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    .title {
      display: flex;
      min-height: 24px;
      align-items: center;
      h3 {
        flex: 1;
        margin: 0;
      }
    }

    .description {
      p {
        margin: 4px 0 8px;
      }
    }

    .end-date {
      margin: 4px 0;
    }

    .tag {
      font-size: 11px;
      margin:8px 0;
      &.closed {
        background: #446CB3;
      }
      &.terminated {
        background: #6c7a89;
      }
      &.running {
        background: #3fc380;
      }
    }

    &:hover {
      box-shadow: 0 0.1875rem 1.5rem rgba(0, 0, 0, 0.2);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/rounds/round-card.vue